export default "__VITE_ASSET__5f4b7d5e__"